import {
  stringToHTML,
  showMessage,
  logMessage,
  isVisible,
  debounce
} from './utils';
import {
  Tabs
} from './tabs';
import {
  updateBasketFromList
} from './action';
import {
  initSlider
} from './photo-slider';
import LazyLoad from 'vanilla-lazyload';

const mainTabs = new Tabs('.tabs--products');

mainTabs.tabClickHandler = function () {
  showProducts();
};

document.addEventListener('scroll', documentScrollHandler);

function documentScrollHandler() {
  if (isVisible(mainTabs.getWrapper())) {
    showProducts();
    document.removeEventListener('scroll', documentScrollHandler);
  }
}

const showProducts = debounce(function () {
  const url = mainTabs.getActiveTitle().dataset.href;
  if (url === null || url === undefined || isLoaded()) {
    return;
  }
  const whenProductsLoad = loadProducts();
  whenProductsLoad(url)
    .catch((error) => {
      console.warn(error);
      logMessage(error);
      if (error.name === 'AbortError') {
        showMessage('Сервер долго не отвечает');
      } else {
        showMessage(error.message);
      }
    });
});

function loadProducts() {
  let result;

  return function (url) {
    if (typeof result === 'undefined') {
      result = async function () {
        let controller = new AbortController();
        setTimeout(() => controller.abort(), 30000);

        const response = await fetch(url, {
          signal: controller.signal
        });
        const html = await response.text();
        const doc = stringToHTML(html).querySelector('ul');
        const container = mainTabs.getActiveContainer();
        container.innerHTML = '';
        container.appendChild(doc);
        const myLazyLoad = new LazyLoad({
          // eslint-disable-next-line camelcase
          elements_selector: '.lazyload'
        });
        myLazyLoad.update();
        initSlider();
        container.classList.add('loaded');
        updateBasketFromList();
        return response;
      };
    }
    return result();
  };
}

function isLoaded() {
  return mainTabs.getActiveContainer().classList.contains('loaded');
}
